module.exports = __webpack_public_path__ + "img/main-recent-100.d1010c29.png";